import clsx from 'clsx';

import './styles.scss';

const Container = ({ children, className }) => (
  <div className={clsx('content-container', className)}>{children}</div>
);

export default Container;
